import * as _ from "lodash";
import * as React from "react";
import { getPath } from "../helpers/PathHelpers";
import baseStyled, { ThemeProvider, useTheme, createGlobalStyle as cGS, ThemeConsumer, css as sc_css, keyframes as sc_keyframes, ThemeContext } from 'styled-components';
import { appendPx } from "./DefaultTheme";
import * as memoizee from "memoizee";
var interpolate = function (iString, data) {
    try {
        var f = function () {
            // eslint-disable-next-line
            return new Function("return `" + iString + "`;").call(data);
        };
        return f();
    }
    catch (_a) {
        return "error in string interpolation";
    }
};
export var SpecificTheming = function (props) {
    var path = getPath(props.component);
    var last = path[path.length - 1];
    return (React.createElement(ThemeProvider, { theme: calculateTheme(useTheme(), last) }, props.children));
};
export function calculateTheme(theme, componentName) {
    var givenOverrideDefinitions = componentName ? theme.components[componentName] : undefined;
    var overrideDefintionsAsArray = givenOverrideDefinitions ?
        (givenOverrideDefinitions.hasOwnProperty("baseDefinition") ? { base: givenOverrideDefinitions } : givenOverrideDefinitions)
        : undefined;
    //    console.log(overrideDefintionsAsArray);
    if (overrideDefintionsAsArray) {
        var t_1 = _.cloneDeep(theme);
        _.forEach(overrideDefintionsAsArray, function (currentOverrideDefinition) {
            //            console.log(" ==== >", currentOverrideDefinition);
            var split = getPath(currentOverrideDefinition.baseDefinition);
            var i = 0;
            var cur = t_1;
            var parent = undefined;
            var lastSplit = "";
            //            console.log("split => ", split, ", cur => ", cur);
            while (split[i] && cur) {
                parent = cur;
                lastSplit = split[i++];
                cur = cur[lastSplit];
                //                console.log("split[i] => ", split[i - 1], ", cur => ", cur);
            }
            //            console.log("found cur => ", cur);
            if (cur) {
                if (typeof currentOverrideDefinition.overrides === "string" || typeof currentOverrideDefinition.overrides === "number" || typeof currentOverrideDefinition.overrides === "boolean") {
                    //                    console.log("primitive");
                    if (parent && lastSplit) {
                        //                        console.log("override : ", lastSplit, " => ", currentOverrideDefinition.overrides);
                        parent[lastSplit] = currentOverrideDefinition.overrides;
                    }
                }
                else
                    _.forEach(currentOverrideDefinition.overrides, function (data, key) {
                        //                        console.log("override : ", key, " => ", data);
                        if (data)
                            cur[key] = data;
                    });
                //                console.log(t);
            }
        });
        return t_1;
    }
    return theme;
}
//export type Theme = typeof theme;
export var styled = baseStyled;
export var createGlobalStyle = cGS;
export var ImgThemeProvider = ThemeProvider;
export var ImgThemeConsumer = ThemeConsumer;
export var css = sc_css;
export var keyframes = sc_keyframes;
var combineThemes = memoizee(function (left, right) {
    //    console.log(`new combining...... ${left.content.width} => ${right.content?.width}`);
    return _.merge(_.cloneDeep(left), right);
}, { max: 100, normalizer: function (args) { return JSON.stringify(args); } });
export var ImgThemeManipulation = React.memo(function (props) {
    var theme = React.useContext(ThemeContext);
    //  const [curTheme, setCurTheme] = React.useState<Theme>(theme);           
    //    console.log(`check for combining...... ${l.content.width} => ${r.content?.width}`);
    var t = combineThemes(theme, props.manipulation(theme));
    // const eq = _.isEqual(t, curTheme);
    // console.log("theme is eq? ", eq)
    // if (!eq) {
    //     const res = _.reduce(t as any, function (result, value, key) {
    //         return _.isEqual(value, (curTheme as any)[key]) ?
    //             result : result.concat(key as any);
    //     }, []);
    //     console.log(res)
    //     setCurTheme(t);
    // }
    return (React.createElement(ImgThemeProvider, { theme: t }, props.children));
});
export var manipulateTheme = function (theme, manipulation) {
    if (manipulation)
        return _.merge(_.cloneDeep(theme), manipulation(theme));
    return theme;
};
export var getDimenions = function (data) {
    if (!data)
        return ["0px", "0px", "0px", "0px"];
    if (typeof data === "string") {
        var split = data.split(" ");
        switch (split.length) {
            case 1:
                return [split[0], split[0], split[0], split[0]];
            case 2:
                return [split[0], split[1], split[0], split[1]];
            case 3:
                return [split[0], split[1], split[2], "0px"];
            case 4:
                return [split[0], split[1], split[2], split[3]];
            default:
                return ["0px", "0px", "0px", "0px"];
        }
    }
    else {
        var val = appendPx(data);
        return [val, val, val, val];
    }
};
export function fromThemeCreator(applicationName) {
    return function (p, selector, altSelector) {
        var at = p.theme.applicationTheming[applicationName];
        var sel = at ? selector(at) : undefined;
        return sel !== null && sel !== void 0 ? sel : altSelector(p.theme);
    };
}
export function fromThemeCreators(applicationName) {
    return {
        withAlt: function (p, selector, altSelector) {
            var at = p.theme.applicationTheming[applicationName];
            var sel = at ? selector(at) : undefined;
            return sel !== null && sel !== void 0 ? sel : (typeof altSelector === "function" ? altSelector(p.theme) : altSelector);
        },
        checkAndSet: function (p, selector, iString, altString) {
            var at = p.theme.applicationTheming[applicationName];
            var sel = at ? selector(at) : undefined;
            return sel ? interpolate(iString, sel) : (altString !== null && altString !== void 0 ? altString : "");
        }
    };
}
export function useThemePart(getter) {
    var theme = React.useContext(ThemeContext);
    var _a = React.useState(getter(theme)), result = _a[0], setResult = _a[1];
    var val = getter(theme);
    if (!_.isEqual(val, result)) {
        setResult(val);
        return val;
    }
    return result;
}
//# sourceMappingURL=ThemeHelpers.js.map